const getDefaultTicketFilters = (user = {}) => {
    const defaultUser = user.role != "7" && user.name
        ? user.name
        : "*";

    return {
        id: '',
        instalacion: '*',
        tipo: '*',
        usuario: defaultUser,
        asunto: '',
        responsable: '*',
        estado: '!CERRADO'
    };
}

export default getDefaultTicketFilters;
